import { post } from '../utils/http';
import { APIResponse } from '../types/api-response';
import { OverallSummaryResponse } from '../types/overallsummary-response';
import { OrganisationParticipantSummaryResponse } from '../types/organisationparticipantsummary-response';

export async function overallSummary(token: string, month: number, year: number): 
  Promise<APIResponse<OverallSummaryResponse[]>> {
  return await post('1.0/admin/overallsummary', { token, month, year });
}

export async function organisationParticipantSummary(token: string, orgId: string): 
  Promise<APIResponse<OrganisationParticipantSummaryResponse[]>> {
  return await post('1.0/admin/organisationparticipantsummary', { token, orgId });
}
